package org.hs_soft.runmynesto.pages.components.checkout.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.getGeneralItemRatio
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.checkout.getArrowImg
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.px


@Composable
fun StoreItem(
    isExpandAll: Boolean,
    checkedValue: Boolean,
    isLastItem:Boolean,
    title: String,
    unCheckItem: () -> Unit,
    checkItem: () -> Unit,
    content: @Composable () -> Unit,
    ratioChecked: String,
    windowSizeMode: WindowSizeModeEnum,
    showCheckBox: Boolean
)
{
    val isHovered= remember{ mutableStateOf(false) }

    val isExpanded= remember{ mutableStateOf(false) }
    LaunchedEffect(isExpandAll){
        isExpanded.value=isExpandAll
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .cursor(Cursor.Pointer)
            .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                isExpanded.value=!isExpanded.value
            },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(
                    if (isHovered.value) Theme.PrimaryStatesHover.rgb
                    else Theme.Transparent.rgb
                )
                .onMouseOver {isHovered.value=true}
                .onMouseLeave { isHovered.value=false }
                .padding(
                    left = Dimen.largePadding,
                    right = Dimen.normalPadding
                )
                .height(Dimen.checkOutItemHeight),
        )
        {
            Box(
                modifier = Modifier
                    .visibility(
                        if(isExpanded.value) Visibility.Visible
                        else Visibility.Hidden
                    )
                    .align(Alignment.BottomStart)
                    .margin(left = Dimen.semiNormalPadding)
                    .height(((Dimen.checkOutItemHeight.value.toInt())/2).px)
                    .backgroundColor(Theme.Gray9E.rgb)
                    .width(Dimen.smallThickness)
            )
            Row(
                modifier = Modifier
                    .align(Alignment.CenterStart),
                verticalAlignment = Alignment.CenterVertically,
            )
            {
                if (showCheckBox){
                    CheckboxComponent(
                        modifier = Modifier ,
                        checkStatus = checkedValue,
                        title = "",
                        onChecked = {
                            checkItem()
                        },
                        onUnChecked = {
                            unCheckItem()
                        },
                    )
                }


                VectorIcon(
                    modifier = Modifier
                        .backgroundColor(
                            if (!showCheckBox) Theme.White.rgb
                            else Theme.Transparent.rgb
                        )
                        .zIndex(4f),
                    pathData = Res.PathIcon.store,
                    width = Dimen.normalIconSize,
                    height = Dimen.normalIconSize,
                    color = Theme.TextDisabled.hex
                )

                SpanText(
                    text = title,
                    modifier = Modifier
                        .margin(left = Dimen.semiNormalPadding)
                        .fontWeight(FontWeight.Normal)
                        .fontFamily(FontFamily.Jakarta)
                        .fontSize(
                            getGeneralItemRatio(
                                windowSizeMode=windowSizeMode,
                                size = FontSizes.mediumFontSize,
                            )
                        )
                        .color(Theme.TextPrimary.rgb),
                )
            }



            Spacer()

            Row(
                modifier = Modifier
                    .align(Alignment.CenterEnd),
                verticalAlignment = Alignment.CenterVertically,

            )
            {
                SpanText(
                    text =ratioChecked ,
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .margin(leftRight = Dimen.smallPadding)
                        .fontWeight(FontWeight.Medium)
                        .fontFamily(FontFamily.Jakarta)
                        .fontSize(FontSizes.normalFontSize)
                        .color(Theme.TextPrimary.rgb),
                )



                VectorIcon(
                    pathData = getArrowImg(expanded = isExpanded.value),
                    width = Dimen.mediumIconSize,
                    height = Dimen.mediumIconSize,
                    color = Theme.ActionActive.hex,
                )
            }



        }

        if (!isExpanded.value && !isLastItem )
            Separator()

        if (isExpanded.value){
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(Theme.White.rgb)
                    .margin(
                        right=Dimen.normalPadding,
                        left = Dimen.normalPadding,
                        top = Dimen.normalPadding,
                        bottom = Dimen.normalPadding,
                    )
                    .width(Dimen.storeItemWidth)

                ,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                content()
            }
        }

//        if (isExpanded.value)
//            Separator()


    }


}
